import Axios from "axios";
import { useContext } from "react";

import { Col, Form } from "react-bootstrap";

import { toast } from "react-toastify";

import hocFrom from "../../../components/forms/HocFrom";
import InputControl from "../../../components/inputs/InputControl";
import InputControlAsync from "../../../components/inputs/InputControlAsync";
import InputPricing from "../../../components/inputs/InputPricing";
import DashboardContext from "../../../Context";
import InputDate from "../../../components/inputs/InputDate";

const FromPaymentReceipt = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata, urlWebsilte, handelForm }) => {

    const { authentication, urldashboard, idview, handelWalletupdate } = useContext(DashboardContext);

    const handelValue = (name, value) => {
        switch (name) {
            case "userId":
                handelsetdataForm({ ...formdata, userId: value })
                break;
            case "paymentReceiptType":
                if (urlWebsilte) {
                    handelsetdataForm({ ...formdata, paymentReceiptType: value, userId: JSON.parse(sessionStorage.getItem('workerId')) ? JSON.parse(sessionStorage.getItem('workerId')) : JSON.parse(sessionStorage.getItem('customerid')) ? JSON.parse(sessionStorage.getItem('customerid')) : idview })
                }
                else {
                    handelsetdataForm({ ...formdata, paymentReceiptType: value })
                }
                break;
            case "amount":
                handelsetdataForm({ ...formdata, amount: parseInt(value) })
                break;
            case "description":
                handelsetdataForm({ ...formdata, description: value })
                break;
            case 'receiptDate':
                handelsetdataForm({ ...formdata, receiptDate: value })
                break;
            default:
                break;
        }
    }


    const sendData = async () => {
        handelLoadingform(true)
        try {
            const res = await Axios.post(`${urldashboard}${urlWebsilte}/create`, JSON.stringify(formdata), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })
            const data = await res.data
            handelLoadingform(false)
            handelForm()
            handelWalletupdate()
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (error) {
            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                handelLoadingform(false)
                handelForm()
            }
            else {
                handelForm()
                handelLoadingform(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        }
    }



    const handelSubmit = event => {
        event.preventDefault()
        handelLoadingform(true)
        if (!formdata.userId) {
            toast.error("لطفا نام را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.paymentReceiptType === undefined) {
            toast.error("لطفا وضعیت تراکنش را انتخاب کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.amount === undefined) {
            toast.error("لطفا مبلغ را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            if (urlWebsilte) {
                sendData()
            }
            else {
                dataUpdate.amount ? handelUpdataFrom() : handelSend()
            }
        }
    }

    return (
        <Form>
            <Form.Row>
                {
                    urlWebsilte ? null
                        :
                        <Col>
                            <InputControlAsync url='/userManagement/searchdropdown' label='نام مشتری یا نیرو' name='userId' handelValue={handelValue} />
                        </Col>
                }
                <Col>
                    <InputControl url='/common/paymentreceipttypedropdown' label='وضعیت تراکنش' name='paymentReceiptType' handelValue={handelValue} />
                </Col>
                <Col>
                    <InputPricing label='مبلغ' name='amount' handelValue={handelValue} />
                </Col>
                <Col>
                    <InputDate label='تاریخ رسید' name='receiptDate' handelValue={handelValue} />
                </Col>
            </Form.Row>
            <Form.Row>
                <Col>
                    <div className="form-group">
                        <label for="descriptionTextarea">توضیحات</label>
                        <textarea className="form-control" id="descriptionTextarea" rows="6" defaultValue={dataUpdate ? dataUpdate.description : ''} onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                    </div>
                </Col>
            </Form.Row>
            <Form.Row>
                <Col>
                    <button type='submit'
                        className='btn btn-success'
                        onClick={handelSubmit}
                        disabled={LoadingForm} >
                        {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> :
                            dataUpdate.amount ? "ثبت ویرایش" : "ثبت"}
                    </button>
                </Col>
            </Form.Row>
        </Form>
    );
}

export default hocFrom(FromPaymentReceipt)
